"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const orange = {
    100: "#4D3721",
    90: "#684928",
    80: "#7C552C",
    70: "#93632E",
    60: "#AD7130",
    50: "#CA822F",
    40: "#E29727",
    30: "#F9AE0F",
    20: "#FFC95F",
    10: "#FFE19F",
    0: "#FDEFC8",
};
exports.default = orange;
//# sourceMappingURL=orange.js.map